import * as L from "leaflet";
import VehichleMarkerIcon from "./truck.png";
import { Marker, Popup } from "react-leaflet";
import { makeStyles, Typography } from "@material-ui/core";
import { Vehicle } from "shared/types";

type Props = {
  longitude: number | null;
  latitude: number | null;
  vehicle?: Vehicle;
};

const useStyles = makeStyles(
  () => ({
    divIcon: {
      background: "transparent",
      border: "none",
    },
    markerContainer: {
      position: "absolute",
      top: "4px",
      fontSize: "12px",
      width: "25px",
      textAlign: "center",
      fontWeight: "bold",
    },
    marker: {
      position: "relative",
      fontSize: "12px",
      width: "25px",
      textAlign: "center",
    },
  }),
  { name: "TourDetails" },
);

const VehicleMapMarker = ({ latitude, longitude, vehicle }: Props) => {
  const classes = useStyles();
  // @ts-ignore
  L.NumberedDivIcon = L.Icon.extend({
    options: {
      iconUrl: VehichleMarkerIcon,
      number: "",
      shadowUrl: null,
      iconSize: [25, 41],
      popupAnchor: [0, -33],
      className: classes.divIcon,
    },
    createIcon: function () {
      var div = document.createElement("div");
      var img = this._createImg(this.options["iconUrl"]);
      var numdiv = document.createElement("div");
      numdiv.setAttribute("class", classes.markerContainer);
      img.setAttribute("class", classes.marker);
      numdiv.innerHTML = this.options["number"] || "";
      div.appendChild(img);
      div.appendChild(numdiv);
      this._setIconStyles(div, "icon");
      return div;
    },
  });

  return (
    <Marker
      position={[latitude || 0, longitude || 0]}
      icon={
        // @ts-ignore
        new L.NumberedDivIcon({
          number: "",
        })
      }
    >
      <Popup>
        <Typography>{vehicle?.licensePlateNumber}</Typography>
      </Popup>
    </Marker>
  );
};

export default VehicleMapMarker;
